import * as ActionTypes from '../ActionTypes';
import { RegisterUserService, LoginUserService, LoginUserStaffService, LogOutUserService, LoadUserService } from '../../services/AuthServices';


export const RegisterAction = (credentials,history,url) => {
    return (dispatch) => {
        dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});
        dispatch({type: ActionTypes.LOADING});

        

        RegisterUserService(credentials).then((res) => {
             
            if(res.hasOwnProperty('success') && res.success === true){
                
                dispatch({type: ActionTypes.SIGNUP_SUCCESS, res});
                history.push(url)
            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({type: ActionTypes.SIGNUP_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}


export const LoginAction = (credentials, history) => {
    return (dispatch) => {
        dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});
        dispatch({type: ActionTypes.LOADING});
        

        


        LoginUserService(credentials).then((res) => {
             
            if(res.hasOwnProperty('success') && res.success === true){
                sessionStorage.setItem('user-token',res.token)
                sessionStorage.setItem('role-users-id', res.data.role_users_id)
                dispatch({ type: ActionTypes.LOGIN_SUCCESS,res});
                setTimeout(() => {
                    if ([1, 2,5,6, 7, 8, 9].includes(res.data.role_users_id)){
                        history.push('/applications-list');
                    }else if (10==res.data.role_users_id){
                        history.push('/chalani');
                    }else{
                    history.push('/customer-details/' + res.data.id);
                    }

                },500);

            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({type: ActionTypes.LOGIN_ERROR,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })

        
    }
}
export const LoginActionStaff = (credentials, history) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.RESTART_AUTH_RESPONSE });
        dispatch({ type: ActionTypes.LOADING });
        




        LoginUserStaffService(credentials).then((res) => {
            if (res.hasOwnProperty('success') && res.success === true) {
                sessionStorage.setItem('user-token', res.token)
                sessionStorage.setItem('role-users-id', res.data.role_users_id)
                dispatch({ type: ActionTypes.LOGIN_SUCCESS, res });
                setTimeout(() => {
                    if ([9,6,2,5,7,8].includes(res.data.role_users_id)) {
                        history.push('/applications-list');
                    }
                    else if(1 == res.data.role_users_id) {
                        history.push('/customers-list');
                    }
                     else if ( 10 == res.data.role_users_id) {
                        history.push('/chalani');
                    } else {
                        history.push('/customer-details/' + res.data.id);
                    }

                }, 500);

            } else if (res.hasOwnProperty('success') && res.success === false) {
               dispatch({ type: ActionTypes.LOGIN_ERROR, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })


    }
}


export const LoadUserCredential = (setProfileDetail,serManualUrl) => {
    return (dispatch) => {
        dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});
    
        LoadUserService().then((res) => {
            if(res.hasOwnProperty('success') && res.success === true){

                setProfileDetail(res)
                if (res.user.role_user.id == 3 || res.user.role_user.id == 4){
                    serManualUrl("https://2079.doed.gov.np/manual/" +"doed_client_user_manual_100200.pdf")
                }else{
                    serManualUrl("https://2079.doed.gov.np/manual/" + "doed_staff_user_manual_555666.pdf")
                }
               
                dispatch({type: ActionTypes.LOAD_USER_SUCCESS,res});
            }else if(res.hasOwnProperty('success') && res.success === false){
                dispatch({ type: ActionTypes.LOAD_USER_SUCCESS,res});
            }
            
        }, error => {
            dispatch({type : ActionTypes.CODE_ERROR, error})
        })
    }
}
export const LogoutAction = (history) => {
    return (dispatch) => {
        dispatch({ type: ActionTypes.RESTART_AUTH_RESPONSE });

        LogOutUserService().then((res) => {

            if (res.hasOwnProperty('success') && res.success === true) {

                dispatch({ type: ActionTypes.LOGOUT_SUCCESS, res });
                if(res.staff){
                    history.push("/staff/login");
                }else{
                    history.push("/user/login"); 
                }
               
            } else if (res.hasOwnProperty('success') && res.success === false) {
                dispatch({ type: ActionTypes.LOGOUT_SUCCESS, res });
            }

        }, error => {
            dispatch({ type: ActionTypes.CODE_ERROR, error })
        })
    }
}



export const ClearAuthStateAction = () => {
    return (dispatch) => {
        dispatch({type: ActionTypes.RESTART_AUTH_RESPONSE});

    }
}
